import type { Messages } from "@/i18n/messages/sq"

export const es: Messages = {
    meta: {
        lang: "es",
        dir: "ltr",
        siteTagline: "Publicaciones, traducciones y cursos",
        siteDescription:
            "El Instituto Germa es una institución cultural y educativa dedicada a la edición, la traducción, los cursos de Corán y la enseñanza de idiomas."
    },

    languageNames: {
        sq: "Albanés",
        en: "Inglés",
        de: "Alemán",
        es: "Español",
        tr: "Turco",
        bs: "Bosnio",
        ar: "Árabe"
    },

    common: {
        home: "Inicio",
        homeAria: "Instituto Germa, página de inicio",
        breadcrumb: "Ruta de navegación",
        mainNav: "Principal",
        menu: "Menú",
        openMenu: "Abrir el menú",
        closeMenu: "Cerrar el menú",
        contactUs: "Contáctenos",
        language: "Idioma",
        chooseLanguage: "Elija el idioma del sitio",
        instituteName: "Instituto Germa"
    },

    nav: {
        libra: "Libros",
        kurani: "Corán",
        videoleksione: "Videolecciones",
        kurse: "Cursos",
        audiolibra: "Audiolibros",
        rrethNesh: "Sobre nosotros",
        kontakt: "Contacto"
    },

    footer: {
        tagline:
            "Publicamos y traducimos literatura islámica, y ofrecemos cursos de lectura del Corán y de idiomas.",
        links: "Enlaces",
        books: "Libros",
        allBooks: "Todos los libros",
        contact: "Contacto",
        contactNote:
            "Escríbanos para pedir libros, inscribirse en un curso o proponernos una colaboración.",
        rights: "Todos los derechos reservados."
    },

    verse: {
        text: "Y di: «¡Señor mío, acrecienta mi conocimiento!»",
        source: "Corán, 20:114"
    },

    home: {
        seoDescription:
            "Libros gratuitos para descargar, videolecciones, audiolibros y cursos de lectura del Corán y de idiomas, del Instituto Germa.",
        hero: {
            eyebrow: "Bienvenidos",
            intro:
                "El Instituto Germa es una institución cultural y educativa. Publicamos libros religiosos, lingüísticos y educativos, preparamos videolecciones y organizamos cursos de lectura del Corán y de idiomas.",
            primaryCta: "Ver las publicaciones",
            secondaryCta: "Inscribirse en un curso",
            pillars: ["Libros", "Videolecciones", "Cursos", "Audiolibros"],
            cue: "Descubra más",
            category: "Publicación",
            viewBook: "Ver el libro",
            previous: "Libro anterior",
            next: "Libro siguiente",
            goTo: "Ir al libro {number}"
        },
        marquee: {
            rowOne: ["Publicaciones", "Traducciones", "Cursos de Corán", "Videolecciones", "Audiolibros", "Idiomas"],
            rowTwo: ["El Abecedario Coránico", "Tajwid", "Conocimiento", "Educación", "Patrimonio", "Método moderno"]
        },
        about: {
            eyebrow: "Sobre el instituto",
            title: "Al servicio del conocimiento y la educación",
            intro:
                "Nuestro trabajo busca ayudar a las personas a aprender, a conocer mejor su religión y a desarrollar sus conocimientos lingüísticos. Por eso cuidamos que nuestros libros y materiales didácticos sean precisos y estén bien explicados, y que nuestros cursos se adapten al nivel y a las necesidades de cada alumno.",
            features: [
                "Edición y traducción de literatura religiosa, lingüística y educativa.",
                "Cursos de lectura del Corán y de idiomas, en línea y presenciales.",
                "Videolecciones y audiolibros que puede seguir por internet."
            ]
        },
        stats: {
            titles: "Títulos publicados",
            languages: "Idiomas de publicación",
            fields: "Áreas de actividad",
            online: "Acceso en línea"
        },
        services: {
            eyebrow: "Lo que ofrecemos",
            title: "Nuestra actividad",
            more: "Saber más",
            items: {
                libra: {
                    title: "Libros",
                    description:
                        "Libros religiosos, lingüísticos y educativos, escritos o traducidos por el Instituto Germa.",
                    cta: "Ver los libros"
                },
                videoleksione: {
                    title: "Videolecciones",
                    description: "Lecciones en vídeo sobre la lectura del Corán y otros temas religiosos y educativos.",
                    cta: "Ver las videolecciones"
                },
                kurse: {
                    title: "Cursos",
                    description: "Cursos de lectura del Corán y de idiomas, presenciales y en línea.",
                    cta: "Ver los cursos"
                },
                audiolibra: {
                    title: "Audiolibros",
                    description: "Nuestras publicaciones leídas en voz alta, para quienes prefieren escuchar.",
                    cta: "Escuchar los audiolibros"
                }
            }
        },
        booksLocal: {
            title: "Libros en español",
            description: "Nuestras ediciones en español, gratuitas para descargar."
        },
        booksOther: {
            title: "Libros en otros idiomas",
            description: "Nuestras publicaciones en albanés y en otros idiomas, también gratuitas para descargar."
        },
        booksCarouselTitle: "Libros que dejan huella",
        booksCarouselDescription:
            "Obras religiosas, educativas y culturales, preparadas con esmero para el lector.",
        seeAllBooks: "Ver todos los libros",
        mostRead: {
            eyebrow: "Elegidos por los lectores",
            title: "Los más leídos",
            description: "Los libros que nuestros lectores abren y descargan con más frecuencia."
        },
        kurani: {
            badge: "Un proyecto especial",
            title: "El Noble Corán",
            subtitle: "Traducción de sus significados al albanés",
            text: "Lea el Corán junto con la traducción de sus significados al albanés realizada por Jusuf H. Kastrati, disponible gratuitamente en Kurani.info.",
            cta: "Sobre la traducción",
            readOn: "Leer en Kurani.info",
            logoAlt: "Logotipo de la plataforma Kurani.info",
            highlights: [
                {
                    title: "Precisión y fidelidad",
                    text: "Los significados de las aleyas se transmiten con cuidado, apoyándose en obras de tafsir de reconocida solvencia."
                },
                {
                    title: "Un albanés claro y fluido",
                    text: "Un albanés natural que procura conservar, en la medida de lo posible, los rasgos propios de la expresión coránica."
                },
                {
                    title: "Notas aclaratorias",
                    text: "Breves explicaciones que ayudan a entender las aleyas allí donde hace falta."
                }
            ]
        }
    },

    cta: {
        eyebrow: "Únase a nosotros",
        title: "Para inscribirse en un curso, pedir nuestras publicaciones o colaborar con nosotros, póngase en contacto.",
        primary: "Ver los cursos",
        secondary: "Contáctenos"
    },

    books: {
        seoTitle: "Libros islámicos",
        seoDescription:
            "El catálogo del Instituto Germa: libros religiosos, educativos y culturales en español, albanés y otros idiomas, con traducción y edición profesionales.",
        listName: "Publicaciones del Instituto Germa",
        title: "Nuestras publicaciones",
        description:
            "Aquí encontrará nuestras publicaciones en español, albanés y otros idiomas, todas gratuitas para descargar.",
        crumb: "Libros",
        searchLabel: "Buscar libros",
        searchPlaceholder: "Buscar por título o autor",
        authorChip: "Autor: {name}",
        clearAuthor: "Quitar el filtro de autor",
        clearSearch: "Borrar la búsqueda",
        categoryLabel: "Categoría",
        allCategories: "Todas las categorías",
        languageLabel: "Idioma",
        allLanguages: "Todos los idiomas",
        readingList: "Mi lista de lectura",
        readingListHintBefore: "Pulse el icono",
        readingListHintAfter: "en cualquier libro para guardarlo aquí.",
        readingListEmpty:
            "Su lista de lectura todavía está vacía. Pulse el marcador en los libros que quiera leer más adelante.",
        foundOne: "1 libro encontrado",
        foundMany: "{count} libros encontrados",
        noResults: "No hay libros que coincidan con estos filtros.",
        showAll: "Mostrar todos los libros",
        groupLocal: "En español",
        groupOther: "En otros idiomas",
        mostRead: "Más leído",
        publishedBy: "Publicado por el Instituto Germa",
        viewBook: "Ver el libro {title}",
        coverAlt: "Portada de {title}",
        save: "Guardar en mi lista",
        saved: "En mi lista",
        remove: "Quitar de mi lista"
    },

    bookPage: {
        lang: "es",
        dir: "ltr",
        about: "Sobre el libro",
        highlights: "Puntos clave",
        details: "Detalles",
        language: "Idioma",
        languageName: "Español",
        category: "Categoría",
        author: "Autor",
        authorLine: "Autor: {author}.",
        publishedBy: "Publicado por el Instituto Germa.",
        fallbackDescription: "{title}. Un libro en {language}.",
        publisher: "Editorial",
        cta: "¿Le interesa este libro? Escríbanos para pedirlo o para recibir más información.",
        contact: "Contáctenos",
        home: "Inicio",
        books: "Libros",
        book: "Libro",
        breadcrumb: "Ruta de navegación",
        coverAlt: "Portada de {title}",
        readOnline: "Leer en línea",
        orderOrAsk: "Pedir o consultar",
        allBooks: "Todos los libros",
        readerTitle: "Leer el libro en línea",
        readerText: "Hojee el libro completo aquí mismo, de forma gratuita.",
        openNewTab: "Abrir en una pestaña nueva",
        relatedEyebrow: "Siga leyendo",
        moreByAuthor: "Más libros de este autor",
        allByAuthor: "Todos los libros del autor",
        authorLinkTitle: "Ver los libros de este autor",
        relatedTitle: "También le puede interesar",
        seeAllBooks: "Ver todos los libros",
        otherEditions: "Este libro en otros idiomas",
        watchVideos: "Ver las videolecciones",
        downloadPdf: "Descargar PDF",
        continueFrom: "Continuar desde la página {page}",
        startOver: "Empezar desde el principio",
        page: "Página",
        pageOf: "de",
        prevPage: "Página anterior",
        nextPage: "Página siguiente",
        zoomIn: "Ampliar",
        zoomOut: "Reducir",
        fullscreen: "Pantalla completa",
        closeReader: "Cerrar el lector",
        loadingBook: "Abriendo el libro…",
        readerError: "No se pudo abrir el libro aquí. Pruebe a abrirlo en una pestaña nueva.",
        saveBook: "Guardar en mi lista",
        savedBook: "En mi lista",
        share: "Compartir",
        copyLink: "Copiar enlace",
        linkCopied: "Enlace copiado",
        email: "Correo electrónico",
        moreOptions: "Más opciones",
        displaySettings: "Vista de lectura",
        themeLight: "Día",
        themeSepia: "Sepia",
        themeNight: "Noche",
        pageSize: "Tamaño del texto",
        reviews: {
            title: "Opiniones de los lectores",
            intro: "¿Qué le ha parecido este libro? Deje una valoración con estrellas y, si quiere, unas palabras para otros lectores.",
            average: "{average} de 5",
            count: "{count} opiniones",
            countOne: "1 opinión",
            empty: "Este libro aún no tiene opiniones. Sea el primero en valorarlo.",
            formTitle: "Valore este libro",
            ratingLabel: "Su valoración",
            star: "{count} estrellas",
            starOne: "1 estrella",
            name: "Su nombre",
            namePlaceholder: "p. ej. Lucía",
            comment: "Comentario (opcional)",
            commentPlaceholder: "¿Qué le gustó de este libro?",
            submit: "Enviar opinión",
            sending: "Enviando…",
            success: "¡Gracias! Su opinión aparecerá cuando el Instituto la haya revisado.",
            errorRating: "Elija cuántas estrellas le da al libro.",
            errorName: "Escriba su nombre (al menos dos letras).",
            errorThrottled: "Hoy ya ha enviado muchas opiniones. Inténtelo de nuevo mañana.",
            error: "No se pudo enviar la opinión. Inténtelo de nuevo en un momento.",
            moderated: "Las opiniones aparecen después de que el Instituto las revise."
        },
        quote: {
            button: "Compartir una cita",
            title: "Compartir una cita",
            intro: "Seleccione una frase en la página del libro con el ratón o con el dedo, o escríbala aquí. La convertimos en una imagen para Instagram o WhatsApp.",
            textLabel: "Cita",
            placeholder: "Escriba o pegue la frase que le conmovió…",
            formatLabel: "Forma de la imagen",
            square: "Cuadrada (publicación)",
            story: "Vertical (historia)",
            share: "Compartir la imagen",
            download: "Descargar la imagen",
            copyText: "Copiar el texto",
            copied: "Texto copiado",
            close: "Cerrar",
            tooLong: "La cita es demasiado larga. Acórtela un poco (hasta {max} caracteres).",
            empty: "Escriba una cita para que aparezca en la imagen.",
            fromSelection: "Compartir como cita",
            preview: "Vista previa de la imagen",
            shareText: "Del libro «{title}»"
        }
    },

    share: {
        share: "Compartir",
        copyLink: "Copiar enlace",
        linkCopied: "Enlace copiado",
        email: "Correo electrónico",
        moreOptions: "Más opciones"
    },

    audiobooks: {
        seoTitle: "Audiolibros islámicos en albanés",
        seoDescription:
            "Audiolibros religiosos y educativos en albanés, leídos con claridad y profesionalidad. Escúchelos en la misma página, cuando quiera y desde cualquier dispositivo.",
        listName: "Audiolibros del Instituto Germa",
        title: "Audiolibros en albanés",
        description:
            "Nuestras publicaciones en formato de audio, en albanés. Puede escucharlas aquí mismo o descargarlas gratuitamente, sin necesidad de registrarse.",
        crumb: "Audiolibros",
        comingSoon: "Próximamente",
        comingSoonText: "Estamos preparando nuestros audiolibros. Siga nuestros canales para ser de los primeros en escucharlos.",
        badge: "Audiolibro",
        author: "Autor:",
        openBook: "Abrir el libro",
        resumeFrom: "Continuar desde {time}",
        back15: "Retroceder 15 segundos",
        forward15: "Avanzar 15 segundos",
        play: "Reproducir",
        pause: "Pausar",
        position: "Posición de reproducción",
        speedGroup: "Velocidad de reproducción",
        speed: "Velocidad",
        speedValue: "Velocidad {value}",
        download: "Descargar el audiolibro",
        youtube: "Escuchar en YouTube",
        miniLabel: "Escuchando ahora",
        closePlayer: "Cerrar el reproductor",
        openAudiobook: "Ir al audiolibro",
        coverAlt: "Portada del audiolibro {title}",
        otherAudiobooks: "Más audiolibros",
        allAudiobooks: "Todos los audiolibros",
        openPage: "Abrir la página del audiolibro",
        pageSeoDescription: "Escuche gratis el audiolibro «{title}» en albanés, directamente en la página, o descárguelo sin registrarse."
    },

    videos: {
        seoTitle: "Videolecciones para aprender a leer el Corán",
        seoDescription:
            "{count} videolecciones gratuitas para aprender las letras del Corán, en albanés, alemán e inglés, desde la primera letra hasta la lectura fluida.",
        listName: "Videolecciones del Instituto Germa",
        title: "Aprenda a leer el Corán",
        description:
            "Las videolecciones del Abecedario Coránico le enseñan paso a paso las letras árabes y la lectura del Corán. Las lecciones están en albanés, alemán e inglés, y puede seguirlas gratis en esta página, sin registrarse.",
        crumb: "Videolecciones",
        chooseLanguage: "Elija un idioma:",
        player: {
            videos: "vídeos",
            youtube: "Ver en YouTube",
            list: "Lista de lecciones",
            promo: "Vídeo de presentación",
            promoShort: "Intro",
            lesson: "Lección",
            of: "de",
            playing: "Reproduciendo",
            shareLesson: "Compartir la lección",
            openBook: "Ver el libro",
            markDone: "Marcar como aprendida",
            done: "Aprendida",
            progress: "aprendidas",
            resume: "Continuar con",
            lessonsDone: "{done} de {total} lecciones aprendidas",
            progressLabel: "Progreso en esta serie",
            seriesDone: "Ha completado esta serie. ¡Enhorabuena!",
            progressHint: "Marque las lecciones que ha aprendido y siga su progreso.",
            prevLesson: "Lección anterior",
            nextLesson: "Lección siguiente",
            allLessons: "Todas las lecciones de la serie",
            watchOnYoutube: "Ver en YouTube",
            aboutLesson: "Sobre esta lección",
            backToSeries: "Volver a la serie",
            openLessonPage: "Abrir la página de la lección",
            lessonIntro: "Lección {number} de {total} de la serie «{series}».",
            promoIntro: "Vídeo de presentación de la serie «{series}».",
            freeLesson: "Una videolección gratuita del Instituto Germa, sin registro."
        }
    },

    courses: {
        seoTitle: "Cursos de Corán y de idiomas",
        seoDescription:
            "Cursos de Corán desde las primeras letras hasta la lectura con tajwid, además de cursos de idiomas. En línea y presenciales, con inscripción abierta.",
        listName: "Cursos del Instituto Germa",
        title: "Cursos de lectura del Corán y de idiomas",
        description:
            "Organizamos cursos para principiantes y para quienes desean ampliar sus conocimientos. Según el curso y el grupo, las clases son en línea o presenciales.",
        crumb: "Cursos",
        posterAlt: "Cartel del curso {title}",
        teacher: "Profesora:",
        details: "Ver los detalles del curso",
        listTitle: "Nuestros cursos",
        listDescription:
            "Enseñamos la lectura del Corán y el tajwid, y tenemos previsto retomar el curso de lengua árabe. Las fechas, los horarios y la forma de inscripción se anuncian para cada nuevo grupo.",
        registerTitle: "¿Le gustaría inscribirse en un curso?",
        registerDescription:
            "Rellene el formulario para mostrarnos su interés. En cuanto se abra un nuevo grupo del curso elegido, nos pondremos en contacto con usted para informarle de la fecha de inicio, el horario y la forma en que se impartirán las clases.",
        plannedSuffix: "reanudación prevista",
        contactFallback: "Contáctenos",
        items: {
            "shkronjat-e-kuranit": {
                title: "Aprender a leer el Corán",
                description:
                    "Un curso para mujeres principiantes basado en el libro El Abecedario Coránico. Se empieza por reconocer y pronunciar las letras árabes, y después se aprende a unirlas en palabras y a practicar la lectura del Corán.",
                level: "Para mujeres principiantes",
                format: "En línea",
                badge: "Para principiantes",
                summary:
                    "Un curso basado en El Abecedario Coránico: desde reconocer y pronunciar las letras árabes hasta unirlas en palabras y practicar la lectura.",
                cta: "Consúltenos por los nuevos grupos"
            },
            "leximi-me-texhvid": {
                title: "Aprender tajwid",
                description:
                    "Aprendizaje y aplicación de las reglas del tajwid, con ejercicios prácticos y corrección de la recitación.",
                level: "Para quienes ya saben leer el Corán",
                format: "En línea",
                badge: "",
                summary: "",
                cta: "Consúltenos por los nuevos grupos"
            },
            "gjuha-arabe": {
                title: "Lengua árabe",
                description:
                    "Un curso para aprender a leer, escribir y comprender el árabe. Los detalles se publicarán cuando se fije la reanudación del curso.",
                level: "Reanudación prevista",
                format: "En línea",
                badge: "",
                summary: "",
                cta: "Pida más información"
            }
        }
    },

    courseForm: {
        name: "Nombre y apellidos",
        phone: "Número de teléfono",
        email: "Correo electrónico",
        course: "Curso que le interesa",
        message: "Mensaje",
        optional: "(opcional)",
        messagePlaceholder: "Indique sus preguntas o peticiones.",
        notice: "Rellenar el formulario no supone una inscripción definitiva en el curso.",
        submit: "Enviar la solicitud",
        submitting: "Enviando…",
        successTitle: "Solicitud enviada",
        successText:
            "Gracias por su interés. Nos pondremos en contacto con usted cuando se abra un nuevo grupo del curso elegido.",
        again: "Enviar otra solicitud",
        errors: {
            name: "Por favor, escriba su nombre.",
            phone: "Por favor, escriba un número de teléfono válido.",
            email: "Por favor, escriba un correo electrónico válido.",
            course: "Por favor, elija un curso.",
            generic: "No se pudo enviar la solicitud. Por favor, inténtelo de nuevo."
        }
    },

    contact: {
        seoTitle: "Contacto",
        seoDescription:
            "Escriba al Instituto Germa para pedir libros, inscribirse en los cursos de Corán y de idiomas o proponer una colaboración. Respondemos lo antes posible.",
        title: "Contáctenos",
        description:
            "Escríbanos para pedir libros, inscribirse en un curso, proponer una colaboración o preguntar por nuestra labor.",
        crumb: "Contacto",
        howTitle: "¿Cómo ponerse en contacto?",
        howText: "Puede escribirnos por correo electrónico o a través del formulario.",
        email: "Correo electrónico",
        response: "Respuesta",
        responseValue: "En un plazo de 3 días",
        follow: "Síganos en las redes sociales"
    },

    contactForm: {
        name: "Nombre y apellidos",
        namePlaceholder: "Su nombre completo",
        email: "Correo electrónico",
        emailPlaceholder: "usted@ejemplo.com",
        subject: "Asunto",
        optional: "(opcional)",
        subjectPlaceholder: "¿Sobre qué nos escribe?",
        message: "Mensaje",
        messagePlaceholder: "Escriba aquí su mensaje.",
        submit: "Enviar el mensaje",
        submitting: "Enviando…",
        successTitle: "¡Gracias!",
        successText: "Su mensaje se ha enviado correctamente. Le responderemos lo antes posible.",
        again: "Enviar otro mensaje",
        errors: {
            name: "Por favor, escriba su nombre.",
            email: "Por favor, escriba un correo electrónico válido.",
            message: "Por favor, escriba un mensaje algo más largo.",
            generic: "No se pudo enviar el mensaje. Por favor, inténtelo de nuevo."
        }
    },

    about: {
        seoTitle: "Sobre nosotros",
        seoDescription:
            "El Instituto Germa es una institución cultural y educativa fundada por Jusuf Kastrati, dedicada a la edición, la traducción y los cursos de Corán y de idiomas.",
        title: "Instituto Germa",
        description: "Al servicio del conocimiento y la educación, a través de los libros y la enseñanza.",
        crumb: "Sobre nosotros",
        missionTitle: "Nuestra misión",
        mission: [
            "El Instituto Germa es una institución cultural y educativa que trabaja en la edición, la traducción y la enseñanza. Publicamos literatura religiosa, lingüística y educativa, organizamos cursos de lectura del Corán y de idiomas, y preparamos videolecciones y materiales didácticos.",
            "En nuestras publicaciones cuidamos especialmente la exactitud del contenido, la calidad de la traducción y la corrección lingüística. En los cursos combinamos la explicación con ejercicios prácticos, adaptados al nivel y a las necesidades de cada alumno."
        ],
        valuesTitle: "Los principios de nuestro trabajo",
        values: [
            {
                title: "Precisión",
                text: "Nos basamos en fuentes fiables y revisamos cada contenido antes de publicarlo, cuidando su exactitud religiosa y lingüística."
            },
            {
                title: "Claridad",
                text: "Usamos un lenguaje fluido y explicaciones comprensibles, y aclaramos los términos y temas que requieren conocimientos previos."
            },
            {
                title: "Atención al alumno",
                text: "Adaptamos las clases a la edad y los conocimientos de cada alumno, damos espacio a sus preguntas y le ayudamos a avanzar paso a paso."
            },
            {
                title: "Responsabilidad",
                text: "Agradecemos las observaciones y sugerencias, y corregimos los errores que se detecten en nuestras publicaciones y materiales."
            }
        ],
        leadership: "Dirección",
        founderShort: "Fundador y director",
        portraitAlt: "Retrato de {name}",
        directorRole: "Fundador y director del Instituto Germa",
        directorBio: [
            "El Instituto Germa está dirigido por su fundador y director, Jusuf Kastrati. Se licenció en la Facultad de Sharía de la Universidad Islámica Imam Muhammad ibn Saud de Riad, en la especialidad de jurisprudencia islámica y sus fundamentos. En la misma universidad cursó también un máster en Cultura Islámica, y actualmente realiza su doctorado en Civilización Islámica en la Universidad Ez-Zitouna de Túnez.",
            "Cuenta con muchos años de experiencia en la traducción de literatura islámica y en la enseñanza. Ha traducido libros religiosos e impartido cursos de lectura del Corán y de lengua árabe, con explicaciones en albanés y en alemán, y ha dedicado una parte especial de su labor a la educación religiosa de los jóvenes."
        ]
    },

    kurani: {
        seoTitle: "El Noble Corán con traducción de sus significados al albanés",
        seoDescription:
            "Lea el texto árabe del Corán junto con la traducción de sus significados al albanés realizada por Jusuf Kastrati, gratis en Kurani.info.",
        title: "El Noble Corán",
        subtitle: "Traducción de sus significados al albanés",
        description:
            "Lea el Corán junto con la traducción de sus significados al albanés realizada por Jusuf H. Kastrati. La traducción está disponible gratuitamente en Kurani.info.",
        crumb: "Corán",
        readOn: "Leer en Kurani.info",
        logoAlt: "Logotipo de la plataforma Kurani.info",
        aboutTitle: "Sobre la traducción",
        about: [
            "Esta traducción se ha preparado para transmitir al lector albanés los significados de las aleyas con precisión y en un albanés claro y fluido. Se apoya en obras de tafsir de reconocida solvencia y ha pasado por numerosas revisiones religiosas y lingüísticas.",
            "Toda traducción es un esfuerzo humano por transmitir los significados de las aleyas y no puede reflejar por completo la riqueza lingüística y semántica del original. Por eso sirve como ayuda para comprender el Corán, mientras que el Corán en sí es el Libro revelado por Allah en lengua árabe."
        ],
        featuresTitle: "Rasgos de la traducción",
        features: [
            {
                title: "Precisión y fidelidad",
                text: "Esmero en transmitir los significados de las aleyas, apoyándose en obras de tafsir fiables."
            },
            {
                title: "Un albanés claro y fluido",
                text: "Un albanés claro y fluido que procura conservar, en la medida de lo posible, los rasgos propios de la expresión coránica."
            },
            {
                title: "Coherencia de estilo y terminología",
                text: "Uso coherente de la terminología y conservación de los términos islámicos ya asentados en albanés."
            },
            {
                title: "Notas breves",
                text: "Aclaraciones que ayudan al lector a entender las aleyas cuando hace falta una explicación adicional."
            },
            {
                title: "Revisión religiosa y lingüística",
                text: "Revisiones sucesivas a cargo de especialistas de cada ámbito, para asegurar la exactitud del sentido y de la expresión en albanés."
            },
            {
                title: "Acceso libre",
                text: "La traducción puede leerse gratis en internet, y la versión digital permite actualizarla con nuevas correcciones y mejoras."
            }
        ],
        translatorBadge: "Traductor",
        translatorRole: "Doctorando en Civilización Islámica",
        translatorText:
            "La traducción de los significados del Noble Corán al albanés es fruto de muchos años de investigación, traducción y edición.",
        teamTitle: "Equipo de edición y revisión",
        roles: {
            religious: "Revisión religiosa",
            consulting: "Asesoría religiosa",
            language: "Revisión lingüística"
        },
        noteTitle: "Nota",
        note: "Esta traducción se encuentra en las fases finales de edición y revisión académica. Agradecemos cualquier observación o sugerencia que ayude a transmitir con la mayor exactitud posible los significados del Noble Corán.",
        writeUs: "Escríbanos",
        ctaTitle: "Lea la traducción",
        ctaText: "En Kurani.info encontrará el texto árabe, la traducción al albanés y las notas aclaratorias.",
        ctaButton: "Abrir Kurani.info"
    },

    search: {
        open: "Buscar",
        title: "Buscar en el portal",
        placeholder: "Buscar libros, audiolibros, videolecciones, cursos…",
        close: "Cerrar la búsqueda",
        hint: "Escriba al menos dos letras para buscar.",
        empty: "No se encontró nada para «{query}».",
        error: "La búsqueda no ha funcionado. Inténtelo de nuevo en un momento.",
        loading: "Buscando…",
        groups: {
            books: "Libros",
            audiobooks: "Audiolibros",
            videos: "Videolecciones",
            courses: "Cursos"
        }
    },

    offline: {
        title: "Está sin conexión",
        text: "Esta página todavía no se ha guardado en este dispositivo. Vuelva a intentarlo cuando tenga conexión. Mientras tanto, puede leer los libros que abrió antes.",
        retry: "Intentar de nuevo",
        home: "Página de inicio",
        savedTitle: "Libros guardados para leer sin conexión",
        savedEmpty: "Todavía no tiene libros guardados. Cada libro que abra en el lector del sitio se guarda automáticamente en este dispositivo."
    },

    pwa: {
        install: "Instalar la aplicación"
    },

    notFound: {
        title: "Página no encontrada",
        text: "Es posible que la página se haya trasladado o que ya no exista. Vuelva a la página de inicio para seguir su camino de aprendizaje.",
        back: "Volver al inicio"
    },

    serverError: {
        title: "Algo ha salido mal",
        text: "Se ha producido un error inesperado por nuestra parte. Por favor, inténtelo de nuevo en unos instantes.",
        back: "Volver al inicio"
    }
}
